const getUserInfo = async (uim) => {
  const userToken = await uim.getJWT();
  const { siloUserId: userId } = uim.getAuthenticatedUser();
  return {
    userId,
    userToken,
  };
};

export { getUserInfo };
